import './App.css';
import {BrowserRouter} from "react-router-dom";
import AppContent from "./AppContent";

function App() {
    return (
        <BrowserRouter future={{ v7_relativeSplatPath: true }}>
            <AppContent />
        </BrowserRouter>
    );
}

export default App;
